import { Environment, IEnvConfig } from "./config.types";

export const envConfig: IEnvConfig = {
  env: Environment.PROD,
};
